function sizeSwitch(item, itemGramos, itemLibras) {
	if (sessionStorage.getItem('sizeSwitch') == 'gramos'){
		$(item).addClass('active');
		itemGramos.removeClass('d-none');
		itemLibras.addClass('d-none');
	}else if (sessionStorage.getItem('sizeSwitch') == 'libras'){
		$(item).removeClass('active');
		itemGramos.addClass('d-none');
		itemLibras.removeClass('d-none');
	}else{
		$(item).removeClass('active');
		itemGramos.addClass('d-none');
		itemLibras.removeClass('d-none');
	}
}

window.addEventListener('load',()=>{
	$('[js-size-switch]').each(function(index, el) {
		var listGramos = $(el).closest('[js-filter]').find('[js-size-switch-gr]');
		var listLibras = $(el).closest('[js-filter]').find('[js-size-switch-lb]');
		sizeSwitch(el, listGramos, listLibras);
	});

	$('.section-collection-product-grid').on('click', '[js-size-switch]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var listGramos = $(this).closest('[js-filter]').find('[js-size-switch-gr]');
		var listLibras = $(this).closest('[js-filter]').find('[js-size-switch-lb]');
		if (sessionStorage.getItem('sizeSwitch') == 'gramos'){
			$(this).removeClass('active');
			sessionStorage.setItem('sizeSwitch', 'libras');
			listGramos.addClass('d-none');
			listLibras.removeClass('d-none');
		}else {
			$(this).addClass('active');
			sessionStorage.setItem('sizeSwitch', 'gramos');
			listGramos.removeClass('d-none');
			listLibras.addClass('d-none');
		}
	});
});